import React,{ Component } from 'react';
import Link from 'react-router-dom/Link';

import {
  Container,
  Col,
  Row
} from 'reactstrap';

class ImpersonationError extends Component {
  render(){
    return (
      <Container>
        <Row>
          <Col xs='12'>
            <br />
            <br />
            <br />
            <h3>
              Well that didn't work...
            </h3>
            <Link to='/superadmin/agencies'>Go Back.</Link>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ImpersonationError;



// WEBPACK FOOTER //
// ./src/routes/ImpersonationError/components/ImpersonationError.js